var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindmill0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m663.25 150-28.125 337.5h-28.125l-28.125-112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m941 777.12-278.25-193.12 14.125-24.375 111.5 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.38 584.12-83.375 80.5-237 39.5 306.38-144.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.38 578.38 23.25 471.62h-75l23.25-471.62c-13.625-5.5-23.25-18.875-23.25-34.625 0-20.75 16.75-37.5 37.5-37.5 20.738 0 37.5 16.75 37.5 37.5 0 15.75-9.625 29.125-23.25 34.625z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindmill0);
export default __webpack_public_path__ + "static/media/windmill_0.4a5c9c65c3b37376b8f35caf176242c0.svg";
export { ForwardRef as ReactComponent };